'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'

/**
 * Captures a PostHog `$pageview` on every App Router navigation via an explicit
 * `usePathname`/`useSearchParams` hook. No-op when PostHog isn't configured.
 */
export const PostHogPageview = () => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const posthog = usePostHog()

  useEffect(() => {
    if (!posthog || !pathname) return
    const qs = searchParams?.toString()
    posthog.capture('$pageview', {
      $current_url: `${window.location.origin}${pathname}${qs ? `?${qs}` : ''}`,
    })
  }, [pathname, searchParams, posthog])

  return null
}
